import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-three-dots',
    templateUrl: './three-dots.component.html',
    styleUrls: ['./three-dots.component.scss'],
    standalone: false
})
export class ThreeDotsComponent {
    @Input() isDarkMode = false;
}
